module.exports = __webpack_public_path__ + "static/media/codex-toolkit-imagegen-settings.41d1b072.png";